import Image from 'next/image';

import { SectionWrapper } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import { APP_FEATURES } from '@/config/landingPage';

const BubbleBackground = () => (
  <div className='absolute inset-0 overflow-hidden rounded-tl-[20px] rounded-tr-[20px] rounded-bl-[20px] rounded-br-[120px]'>
    <div className='pointer-events-none absolute -bottom-12 sm:-bottom-16 right-6 sm:right-10 h-72 sm:h-96 w-72 sm:w-96 rounded-full bg-white/15' />
    <div className='pointer-events-none absolute bottom-6 sm:bottom-8 right-20 sm:right-28 h-20 sm:h-28 w-20 sm:w-28 rounded-full bg-white/20' />
  </div>
);

const HeroMobileShowcase = () => {
  return (
    <SectionWrapper className='relative xs:pb-64 sm:pb-80 md:pb-80 lg:pb-20'>
      <div
        className={`relative bg-brand-gradient text-white rounded-tl-[20px] rounded-tr-[20px] rounded-bl-[20px] rounded-br-[120px] overflow-visible`}
      >
        <BubbleBackground />
        <div className='relative inset-0 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center px-6 sm:px-10 lg:px-16 xs:pt-4 lg:pt-0'>
          <div className='z-10'>
            <div className='sm:text-3xl xs:text-2xl md:text-4xl xs:text-center lg:text-left lg:text-5xl text-6xl font-bold text-white mb-4'>
              Your Business,
              <br /> In Your Pocket
            </div>
            <div className='text-white/90 mb-8 xs:text-xs sm:text-sm md:text-base lg:text-xl xs:justify-self-center lg:justify-self-start'>
              Track bookings, manage orders, and get realtime updates — all
              from one powerful mobile app.
              <div className='flex justify-center mt-3 sm:mt-4 gap-2'>
                <div className='lg:hidden xs:block sm:block md:block hidden h-0.5 w-16 xs:w-10 bg-white rounded-full' />
                <div className='lg:hidden xs:block sm:block md:block hidden h-0.5 w-4 xs:w-4 bg-white rounded-full' />
              </div>
            </div>

            <div className='space-y-4'>
              {APP_FEATURES.map(({ description, icon, title }, idx) => (
                <div
                  key={idx}
                  className='flex items-center bg-white/10 rounded-lg px-4 py-3 backdrop-blur-sm'
                >
                  <div className='relative lg:w-10 lg:h-10 xs:w-6 xs:h-6 md:w-8 md:h-8 flex-shrink-0'>
                    <Image
                      alt={title}
                      className='object-contain'
                      fill
                      src={`${staticMediaStoreBaseURL}/landing-page/hero-mobile-showcase/${icon}`}
                    />
                  </div>
                  <div className='ml-4'>
                    <div className='font-semibold text-white lg:text-base xs:text-xs sm:text-sm md:text-base'>
                      {title}
                    </div>
                    <div className='text-white/80 lg:text-sm xs:text-[10px] sm:text-xs md:text-base'>
                      {description}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className='relative lg:flex justify-center items-center'>
            <div className='relative lg:-mt-12 lg:-mb-12 xs:-mt-4 xs:-mb-48 justify-self-center'>
              <Image
                alt='App Mockup'
                className='object-contain w-[260px] sm:w-[340px] lg:w-[453px] h-auto'
                height={802}
                priority
                src={`${staticMediaStoreBaseURL}/landing-page/hero-mobile-showcase/phone-mockup.png`}
                width={453}
              />
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default HeroMobileShowcase;
